import { DISABLE_IMAGE_REQUEST, DISABLE_IMAGE_SUCCESS, DISABLE_IMAGE_FAILURE } from '../actions/disable_image'

export const disableImage = (
  state = {
    isFetching: false,
    errorMessage: null,
  },
  action
) => {
  switch (action.type) {
    case DISABLE_IMAGE_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      }
    case DISABLE_IMAGE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
      }
    case DISABLE_IMAGE_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}
